// Module
var code = "<alert-builder selected-log=\"selectedLog\"></alert-builder>";
// Exports
module.exports = code;